export default __webpack_public_path__ + "static/media/deadlift.76110f11.png";